import React from 'react';
import { MapContext } from '@react-google-maps/api';

const OverlappingMarkerSpiderfier =
  typeof window !== 'undefined' ? window.OverlappingMarkerSpiderfier : null;

class Spiderfy extends React.Component {
  constructor(props) {
    super(props);
    this.oms = OverlappingMarkerSpiderfier
      ? new OverlappingMarkerSpiderfier(MapContext._currentValue, {
          circleFootSeparation: 50,
          legWeight: 1,
          spiralLengthStart: 20,
        })
      : null;
    this._markers = new Set();
    this.markerNodeMounted = this.markerNodeMounted.bind(this);
  }

  markerNodeMounted(ref) {
    setTimeout(() => {
      if (!ref || !ref.marker || !this.oms) return;
      this.oms.addMarker(ref.marker);
      this._markers.add(ref.marker);
      window.google.maps.event.addListener(ref.marker, 'spider_click', (e) => {
        if (this.props.onSpiderClick) this.props.onSpiderClick(e);
      });
    }, 2000);
  }

  componentWillUnmount() {
    try {
      this._markers.forEach((m) => {
        try {
          if (m.setMap) m.setMap(null);
        } catch (_) {}
      });
      this._markers.clear();
      if (this.oms?.clearMarkers) {
        this.oms.clearMarkers();
      } else if (this.oms?.removeAllMarkers) {
        this.oms.removeAllMarkers();
      }
    } catch (_) {}
  }

  render() {
    return React.Children.map(this.props.children, (child) =>
      React.cloneElement(child, { ref: this.markerNodeMounted }),
    );
  }
}

export default Spiderfy;
